/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserBackpackResponse } from '../../models/get-user-backpack-response';

export interface BackpackServiceGetUserBackpack$Params {
  userUuid: string;
  discordId?: string;
}

export function backpackServiceGetUserBackpack(http: HttpClient, rootUrl: string, params: BackpackServiceGetUserBackpack$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserBackpackResponse>> {
  const rb = new RequestBuilder(rootUrl, backpackServiceGetUserBackpack.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserBackpackResponse>;
    })
  );
}

backpackServiceGetUserBackpack.PATH = '/api/v3/gateway/user/{userUuid}/backpack';
